import React, { Component, useState, useEffect } from 'react';
import { Nav, Navbar, NavDropdown, Col, Container, Row } from 'react-bootstrap';
import { Amplify, Auth } from 'aws-amplify';
import aws_exports_default from './aws-exports';
import aws_exports_ugt from './aws-exports_ugt';
import { Header } from 'semantic-ui-react';


import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useRouteMatch,
  useParams,
  withRouter
} from "react-router-dom";

import Home from './components/Home';
import KnowP450s from './components/KnowP450s';
import Email from './components/Email';
import PCPD_Result from './components/PCPD_Result';
import Contact from './components/Contact';
import NavBar from './components/NavBar1';
import Footer from './components/Footer';
import Loader1 from './components/Loader1';
import './App.css';
import PCPD_Queue from './components/PCPD_Queue';
import SubstrateSimi from './components/SubstrateSimi';
import ESP from './components/ESP';
import ESP_Result from './components/ESP_Result';
import ESP_Detail from './components/ESP_Detail';
import PostEmail from './components/PostEmail';
import AF_Submission from './components/AF_Submission';
import Blast_Submission from './components/Blast_Submission_old';
import Blast_Result from './components/Blast_Result';
import Blast_Detail from './components/Blast_Detail';

// Amplify.configure(aws_exports);


const RoouterApp = ({ location }) => {

  const [isLoaded, setIsLoaded] = useState(false);
  const [isLoaded2, setIsLoaded2] = useState(false);

  useEffect(() => {
    if (location !== undefined) {
      let aws_exports;
      if (location.pathname.startsWith('/blast_')) {
        aws_exports = aws_exports_ugt;
      } else {
        aws_exports = aws_exports_default;
      }
      Amplify.configure(aws_exports);
    }
  }, [location]);

  return (
    <Switch>
      <Route path="/contact" >
        <Contact />
      </Route>

      <Route path="/submit" >
        <Email />
      </Route>

      <Route path="/blast_submit" >
        <Blast_Submission />
      </Route>

      <Route path="/blast_results" >
        <Blast_Result />
      </Route>

      <Route path="/blast_detail/:id" >
        <Blast_Detail />
      </Route>

      <Route path="/af_submit" >
        <AF_Submission />
      </Route>

      <Route path="/results" >
        <PCPD_Result />
      </Route>

      <Route path="/queue" >
        <PCPD_Queue />
      </Route>

      <Route path="/tables" >
        <KnowP450s />
      </Route>

      <Route path="/substrate" >
        <SubstrateSimi />
      </Route>

      <Route path="/esp" >
        <ESP />
      </Route>

      <Route path="/esp-results" >
        <ESP_Result />
      </Route>

      <Route path="/esp-detail/:id" >
        <ESP_Detail />
      </Route>

      <Route path="/loader" >
        <Loader1 />
      </Route>

      <Route path="/submission" >
        <PostEmail />
      </Route>

      <Route path="/" >
        <Home />
      </Route>
    </Switch>
  )
}

const AppWithRouter = withRouter(RoouterApp);

export default function App() {
  return (
    <div>
      <div style={{
        height: "20px"
      }}></div>
      <div className="box">
        <Row>
          <Col md={1}>

          </Col>
          <Col md={10}>
            <div className="Header1">
              <Row>
                <div><img alt="" src="./logo.png" style={{
                  width: "100px",
                  marginLeft: "15px"
                }} /></div>

                <Header as='h1' icon textAlign='center' >
                  <Header.Content><span className="Title">Plant Cytochrome P450  Database</span></Header.Content>
                </Header>


                <div><img alt="" src="./structure.png" style={{
                  width: "175px",
                  marginRight: "15px"
                }} /></div>
              </Row>
              <NavBar />
            </div>


            <div>
              <Router>
                <AppWithRouter />
              </Router>
            </div>
            <Footer />

          </Col>
          <Col md={1}>

          </Col>
        </Row>


      </div>
    </div>

  );
}
